import 'css-chunksrc/client/common/weekCalendar/styles.scss';export default {
  "calendar": "_calendar_1mdi0_1",
  "days": "_days_1mdi0_6",
  "month": "_month_1mdi0_9",
  "months": "_months_1mdi0_12",
  "year": "_year_1mdi0_15",
  "years": "_years_1mdi0_18"
};